import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../css/dashboard.css";
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components";
import { useAuthContext } from '../../common/ProtectedLayout';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

function TotalBiling(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuthContext();

    // ✅ 모달 제어를 위한 ref 생성
    const modalCorrective = useRef(); // 기존 상세 모달
    const modalGallery = useRef();    // 갤러리 모달
    const modalImageViewer = useRef(); // 이미지 확대 모달
    const modalSelection = useRef();   // 예약번호 선택 모달
    const modalOrderList = useRef(); // 오더 리스트 모달 Ref 추가

    // --- 상태 관리 ---
    const [isValidAccess, setIsValidAccess] = useState(false);
    const [bilingList, setBilingList] = useState([]);

    // 필터 상태 (클라이언트 사이드 필터링 - 현재 페이지 내에서 동작)
    const [filters, setFilters] = useState({
        신청: true,
        완료: true,
        반려: true
    });

    // 오더 리스트 상태
    const [orderListState, setOrderListState] = useState({
        isOpen: false,
        orders: []
    });

    const [page, setPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState(''); // 실제 검색에 사용될 쿼리
    const [inputQuery, setInputQuery] = useState(''); // 입력창 값
    const items = 10;
    // Total count for pagination needs to be handled cautiously if API only returns a slice without total count.
    // However, biling.js pagination logic relies on 'filteredBilingList.length' which is just the current page slice?
    // Wait, biling.js `totalItemsCount` calculation is:
    // `filteredBilingList.length < items ? (page - 1) * items + filteredBilingList.length : (page * items) + 1`
    // This implies "infinite scroll" style pagination where we assume there's a next page if current page is full.
    // We'll keep this logic.

    const [selectedBiling, setSelectedBiling] = useState(null);
    const [viewImage, setViewImage] = useState(null); // 이미지 확대 모달용

    // 갤러리 모달용 상태
    const [galleryState, setGalleryState] = useState({
        isOpen: false,
        type: '',
        images: [],
        userId: '',
        reservationId: ''
    });

    const [bilingCount, setBilingCount] = useState(0);

    // 예약번호가 여러 개일 때 선택 모달 상태
    const [selectionState, setSelectionState] = useState({
        isOpen: false,
        type: '', // '완료사진' or 'A/S자료'
        reqNumbers: [] // 선택 가능한 예약번호 리스트
    });

    // 상세 리스트 조회
    const getActiveStates = useCallback(() => {
        const allStates = ['신청', '완료', '반려'];
        const activeStates = Object.entries(filters)
            .filter(([_, isActive]) => isActive)
            .map(([state, _]) => state);
        // 모든 필터가 선택된 경우 빈 문자열 반환 (전체 조회)
        if (activeStates.length === allStates.length) return '';
        // 아무것도 선택되지 않은 경우도 전체 조회
        if (activeStates.length === 0) return '';
        return activeStates.join(',');
    }, [filters]);

    const getBilingRegist = useCallback(async (currentPage) => {
        try {
            const pageParam = currentPage - 1;
            const params = {};
            if (searchQuery.trim() !== '') params.query = searchQuery;
            const statesParam = getActiveStates();
            if (statesParam) params.states = statesParam;

            const payoutResult = await axios.get(`/PayoutList/Total/${pageParam}`, { params });
            const payoutData = payoutResult.data.message;

            if (!payoutData || payoutData.length === 0) {
                setBilingList([]);
                return;
            }

            const combinedList = await Promise.all(payoutData.map(async (item) => {
                try {
                    // Manager info is already joined in the new API, but let's see if we need to fetch more?
                    // The new API returns: p.*, m.name, m.bank, m.bank_num 
                    // biling.js fetched manager info separately: axios.get(`/ManagerRegist/EmailID/${item.manager_id}`)
                    // Our new API already joins this.
                    // However, to keep object structure identical to biling.js (which uses 'mg_name'), we need to map it.
                    // New API 'name' is the manager name.

                    return {
                        ...item,
                        mg_name: item.name || "정보없음", // API joins 'name' from manager_regist
                        bank: item.bank || "",
                        bank_number: item.bank_num || "",
                        // phone_num might be missing if we didn't join it, but let's check the SQL. 
                        // SQL: SELECT p.*, m.name, m.bank, m.bank_num ... 
                        // It doesn't select phone_num. If needed, we can add it to SQL, but biling.js uses it? 
                        // biling.js: phone_num: managerInfo?.phone_num || ""
                        // Let's assume phone_num isn't critical for the list view or details shown in modal based on `biling.js` rendering.
                        // Modal shows: number, mg_name, bank, bank_number. Phone number isn't shown in modal or table.

                        confirm_photo: item.confirm_picture || item.comfirm_picture || null,
                        confirm_as: item.confirm_as || item.comfirm_as || null,
                        confirm_paper: item.confirm_import || item.comfirm_import || null,
                        description: item.description || "",
                        reservation_no: item.list ? item.list.split(',')[0].trim() : item.number,
                        tax_invoice_img: item.tax_invoice_img || null
                    };
                } catch (err) {
                    return { ...item, mg_name: "정보없음" };
                }
            }));
            setBilingList(combinedList);
        } catch (error) {
            setBilingList([]);
        }
    }, [searchQuery, getActiveStates]);

    // 전체 개수 조회
    const getBilingCount = useCallback(async () => {
        try {
            const params = {};
            if (searchQuery.trim() !== '') params.query = searchQuery;
            const statesParam = getActiveStates();
            if (statesParam) params.states = statesParam;

            console.log('Fetching count with params:', params);
            const res = await axios.get('/PayoutList/TotalCount', { params });
            console.log('Count API response:', res.data);
            if (res.data.success) {
                // ✅ [Fix] 명시적 숫자 변환으로 NaN 방지
                const count = Number(res.data.count) || 0;
                setBilingCount(count);
            } else {
                setBilingCount(0);
            }
        } catch (error) {
            console.error("Count fetch error:", error);
            setBilingCount(0);
        }
    }, [searchQuery, getActiveStates]);

    // 필터 변경 시 페이지 리셋 및 데이터 재조회
    useEffect(() => {
        setPage(1);
    }, [filters]);

    // --- 이벤트 핸들러 ---
    const handlePageChange = (page) => { setPage(page); };

    // 검색 핸들러
    const handleSearch = () => {
        setPage(1); // 검색 시 페이지를 1로 리셋
        setSearchQuery(inputQuery); // 입력값을 검색어로 설정
        // useEffect가 searchQuery 변경을 감지하여 getBilingRegist 호출
    };

    // Enter 키 핸들러
    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleRowClick = async (item) => {
        // 1. 기본 선택 상태 설정
        const initialItem = { ...item, as_list: [], as_exist: false };
        setSelectedBiling(initialItem);

        // 2. 모달 열기
        modalCorrective.current.showModal();

        // 3. AS 정보 비동기 조회 (매니저 ID 기반)
        if (item.manager_id) {
            try {
                const res = await axios.get(`/AsRegistID/${item.manager_id}`);
                if (res.data.success && res.data.message.length > 0) {
                    const asHistory = res.data.message;

                    let currentReqNumbers = [];
                    if (item.list) {
                        currentReqNumbers = item.list.split(',').map(str => str.trim()).filter(str => str !== "");
                    } else {
                        currentReqNumbers = [item.number];
                    }

                    const matchedAS = asHistory.filter(asItem => currentReqNumbers.includes(asItem.req_number));
                    const matchedASList = [...new Set(matchedAS.map(asItem => asItem.req_number))];

                    setSelectedBiling(prev => ({
                        ...prev,
                        as_list: matchedASList,
                        as_exist: matchedASList.length > 0
                    }));
                }
            } catch (error) {
                console.error("AS History fetch error:", error);
            }
        }
    };

    const toggleFilter = (status) => {
        setFilters(prev => ({ ...prev, [status]: !prev[status] }));
    };

    const handleConfirm = async (type) => {
        if (!selectedBiling) return;
        const confirmerName = auth.loginId === 'admin' ? "관리자" : auth.loginId;
        const url = "/Payout/ConfirmUpdate";
        let body = { idx: selectedBiling.idx };
        let stateKey = "";

        if (type === 'photo') {
            body.confirm_picture = confirmerName;
            stateKey = "confirm_photo";
        } else if (type === 'as') {
            body.confirm_as = confirmerName;
            stateKey = "confirm_as";
        } else if (type === 'paper') {
            body.confirm_import = confirmerName;
            stateKey = "confirm_paper";
        }

        try {
            const res = await axios.patch(url, body);
            if (res.data.success) {
                const updatedBiling = { ...selectedBiling, [stateKey]: confirmerName };
                setSelectedBiling(updatedBiling);
                setBilingList(prevList => prevList.map(item =>
                    item.idx === selectedBiling.idx ? updatedBiling : item
                ));
            } else {
                alert("수정에 실패했습니다: " + res.data.message);
            }
        } catch (error) {
            console.error("Update failed:", error);
            alert("업데이트 중 오류가 발생했습니다.");
        }
    };

    const handleStatusChange = async (newStatus) => {
        if (!selectedBiling) return;
        let description = "";

        if (newStatus === "반려") {
            description = prompt("반려 사유를 입력해주세요.");
            if (description === null) return;
            if (description.trim() === "") {
                alert("반려 사유를 입력해야 합니다.");
                return;
            }
        } else if (newStatus === "완료") {
            if (!window.confirm("지급 처리를 완료하시겠습니까?")) return;
        }

        const urlConfirm = "/Payout/ConfirmUpdate";
        const bodyConfirm = {
            idx: selectedBiling.idx,
            payout_state: newStatus,
            description: description
        };

        try {
            const resConfirm = await axios.patch(urlConfirm, bodyConfirm);

            if (resConfirm.data.success) {
                if (newStatus === "반려") {
                    try {
                        const reqNumPayload = selectedBiling.list ? selectedBiling.list : selectedBiling.number;
                        const urlCompanion = "/Payout/Companion";
                        const bodyCompanion = { req_num: reqNumPayload };
                        const resCompanion = await axios.put(urlCompanion, bodyCompanion);
                        console.log("오더 초기화 결과:", resCompanion.data.message);
                    } catch (err) {
                        console.error("오더 초기화 실패:", err);
                        alert("정산 상태는 반려로 변경되었으나, 오더 초기화 중 오류가 발생했습니다.");
                    }
                }
                alert(`${newStatus} 처리가 완료되었습니다.`);
                modalCorrective.current.close();
                getBilingRegist(page);
            } else {
                alert("처리 실패: " + resConfirm.data.message);
            }
        } catch (error) {
            console.error("Status update failed:", error);
            alert("처리 중 오류가 발생했습니다.");
        }
    };

    const fetchAndOpenGallery = async (targetReqNum, type) => {
        try {
            setSelectionState(prev => ({ ...prev, isOpen: false }));
            const userRes = await axios.get(`/Reservation/UserInfo/ReservationNum/${targetReqNum}`);
            const userId = userRes.data[0]?.user_id;

            if (!userId) {
                alert(`예약번호(${targetReqNum})의 사용자 정보를 찾을 수 없습니다.`);
                return;
            }

            let apiUrl = "";
            let galleryType = "";

            if (type === '완료사진') {
                apiUrl = `/imagesName/work_process/${userId}/${targetReqNum}`;
                galleryType = 'work';
            } else if (type === 'A/S자료') {
                apiUrl = `/imagesName/as_complete/${userId}/${targetReqNum}`;
                galleryType = 'as';
            }

            const imgRes = await axios.get(apiUrl);

            if (imgRes.data.success) {
                const imageNames = imgRes.data.images || [];
                if (imageNames.length === 0) {
                    alert("등록된 사진 내역이 없습니다.");
                    return;
                }
                setGalleryState({
                    isOpen: true,
                    type: galleryType,
                    images: imageNames,
                    userId: userId,
                    reservationId: targetReqNum
                });
            } else {
                alert("등록된 사진 내역이 없습니다.");
            }
        } catch (error) {
            console.error("Image fetch error:", error);
            if (error.response && (error.response.status === 404 || error.response.status === 500)) {
                alert("등록된 사진 내역이 없습니다.");
            } else {
                alert("이미지를 불러오는 중 오류가 발생했습니다.");
            }
        }
    };

    // 세금계산서 이미지(수입자료) 불러오기 - 매니저 경로 사용
    const fetchAndOpenTaxImage = async (payoutNum, managerId) => {
        try {
            if (!managerId) {
                alert("매니저 정보를 찾을 수 없습니다.");
                return;
            }

            // 매니저가 업로드한 세금계산서 이미지 경로
            const imageUrl = `/image/manager/tax/${managerId}/${payoutNum}`;
            try {
                await axios.get(imageUrl);
                setViewImage(imageUrl);
            } catch (err) {
                alert("등록된 수입자료(세금계산서) 이미지가 없습니다.");
            }
        } catch (error) {
            console.error("Tax image fetch error:", error);
            alert("이미지를 불러오는 중 오류가 발생했습니다.");
        }
    };

    const handleViewAttachment = async (type) => {
        if (!selectedBiling) return;

        if (type === '수입자료') {
            const payoutNum = selectedBiling.number;
            const managerId = selectedBiling.manager_id;
            fetchAndOpenTaxImage(payoutNum, managerId);
            return;
        }

        let reqNumbers = [];
        if (type === 'A/S자료' && selectedBiling.as_list && selectedBiling.as_list.length > 0) {
            reqNumbers = selectedBiling.as_list;
        } else if (selectedBiling.list) {
            reqNumbers = selectedBiling.list.split(',').map(str => str.trim()).filter(str => str !== "");
        } else {
            reqNumbers = [selectedBiling.number];
        }

        // B공고 필터링 (사진첨부 없음)
        reqNumbers = reqNumbers.filter(num => !num.startsWith('B'));

        if (reqNumbers.length === 1) {
            fetchAndOpenGallery(reqNumbers[0], type);
        } else if (reqNumbers.length > 1) {
            setSelectionState({
                isOpen: true,
                type: type,
                reqNumbers: reqNumbers
            });
        } else {
            alert("예약 번호가 존재하지 않습니다.");
        }
    };;

    const closeGallery = () => {
        setGalleryState({ isOpen: false, type: '', images: [], userId: '', reservationId: '' });
    };

    const handleViewOrderList = () => {
        if (!selectedBiling) return;
        let orders = [];
        if (selectedBiling.list) {
            orders = selectedBiling.list.split(',').map(str => str.trim()).filter(str => str !== "");
        } else {
            orders = [selectedBiling.number];
        }
        setOrderListState({
            isOpen: true,
            orders: orders
        });
    };

    const handleOrderClick = async (reqNum) => {
        setOrderListState({ isOpen: false, orders: [] });
        modalCorrective.current.close();

        // B공고 분기 처리
        if (reqNum.startsWith('B')) {
            try {
                const res = await axios.get(`/NoticeList/ByReqNumber/${reqNum}`);
                if (res.data.success && res.data.idx) {
                    navigate('/noticelist_detail', { state: { idx: res.data.idx, beforePage: '/total_biling' } });
                } else {
                    alert('해당 공고를 찾을 수 없습니다.');
                }
            } catch (error) {
                alert('공고 조회 중 오류가 발생했습니다.');
            }
        } else {
            navigate('/listdetail', { state: { req_number: reqNum, beforePage: '/total_biling' } });
        }
    };;

    const isAllConfirmed = selectedBiling?.confirm_photo && selectedBiling?.confirm_as && selectedBiling?.confirm_paper;
    const isFinished = selectedBiling?.payout_state === "반려" || selectedBiling?.payout_state === "완료";

    // --- useEffect ---
    useEffect(() => {
        if (galleryState.isOpen && modalGallery.current) modalGallery.current.showModal();
        else if (!galleryState.isOpen && modalGallery.current) modalGallery.current.close();
    }, [galleryState.isOpen]);

    useEffect(() => {
        if (viewImage && modalImageViewer.current) modalImageViewer.current.showModal();
        else if (!viewImage && modalImageViewer.current) modalImageViewer.current.close();
    }, [viewImage]);

    useEffect(() => {
        if (selectionState.isOpen && modalSelection.current) modalSelection.current.showModal();
        else if (!selectionState.isOpen && modalSelection.current) modalSelection.current.close();
    }, [selectionState.isOpen]);

    useEffect(() => {
        if (orderListState.isOpen && modalOrderList.current) modalOrderList.current.showModal();
        else if (!orderListState.isOpen && modalOrderList.current) modalOrderList.current.close();
    }, [orderListState.isOpen]);

    useEffect(() => {
        setIsValidAccess(true);
        getBilingRegist(page);
        getBilingCount();
    }, [page, getBilingRegist, getBilingCount]);

    if (!isValidAccess) return null;

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <TopControlContainer>
                    <SearchContainer>
                        <SearchInput
                            type="text"
                            placeholder="매니저명, 원장번호, 은행, 계좌, 오더번호로 검색..."
                            value={inputQuery}
                            onChange={(e) => setInputQuery(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                        <SearchButton onClick={handleSearch}>검색</SearchButton>
                    </SearchContainer>

                    <FilterContainer>
                        <label className="checkbox-label"><input type="checkbox" checked={filters.신청} onChange={() => toggleFilter('신청')} /><span className="indicator apply"></span> 정산신청</label>
                        <label className="checkbox-label"><input type="checkbox" checked={filters.완료} onChange={() => toggleFilter('완료')} /><span className="indicator complete"></span> 정산완료</label>
                        <label className="checkbox-label"><input type="checkbox" checked={filters.반려} onChange={() => toggleFilter('반려')} /><span className="indicator reject"></span> 정산반려</label>
                    </FilterContainer>
                </TopControlContainer>

                <div style={{ marginTop: '30px' }}>
                    <CommonTable headerTitle={['No', '매니저이름', '은행명', '계좌번호', '원장번호', '포함된 오더', '공급가액', '부가세', '완료사진', 'A/S', '수입자료', '출금신청일자', '상태']}>
                        {bilingList.length > 0 ? (
                            bilingList.map((item, index) => (
                                <CommonTableRow key={index} idx={item.idx} beforePage={'/total_biling'} kind={'notDetail'} onClick={() => handleRowClick(item)}>
                                    <CommonTableColumn>{bilingCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                    <CommonTableColumn>{item.mg_name}</CommonTableColumn>
                                    <CommonTableColumn>{item.bank}</CommonTableColumn>
                                    <CommonTableColumn>{item.bank_number}</CommonTableColumn>
                                    <CommonTableColumn>{item.number}</CommonTableColumn>
                                    <CommonTableColumn>
                                        {item.list && item.list.length > 20 ? item.list.substring(0, 20) + "..." : item.list}
                                    </CommonTableColumn>
                                    <CommonTableColumn>{Math.round(Number(String(item.total_payment).replace(/[^0-9]/g, '')) / 1.1).toLocaleString()}</CommonTableColumn>
                                    <CommonTableColumn>{(Number(String(item.total_payment).replace(/[^0-9]/g, '')) - Math.round(Number(String(item.total_payment).replace(/[^0-9]/g, '')) / 1.1)).toLocaleString()}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_photo ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_photo}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_as ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_as}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.confirm_paper ? <span style={{ color: 'blue', fontWeight: 'bold' }}>{item.confirm_paper}</span> : "-"}</CommonTableColumn>
                                    <CommonTableColumn>{item.regi_date}</CommonTableColumn>
                                    <CommonTableColumn><span style={{ fontWeight: 'bold', color: item.payout_state === '신청' ? '#006edc' : item.payout_state === '완료' ? '#28a745' : item.payout_state === '반려' ? '#dc3545' : 'black' }}>{item.payout_state}</span></CommonTableColumn>
                                </CommonTableRow>
                            ))
                        ) : (
                            <tr><td colSpan="12" style={{ textAlign: "center", padding: "20px" }}>해당 조건의 내역이 없습니다.</td></tr>
                        )}
                    </CommonTable>
                </div>

                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={bilingCount}
                        pageRangeDisplayed={10}
                        onChange={handlePageChange}
                    />
                </PaginationBox>
            </div>

            {/* 상세 모달 */}
            <dialog ref={modalCorrective} style={{ borderRadius: '12px', border: 'none', width: '600px', padding: '0', boxShadow: '0 4px 20px rgba(0,0,0,0.15)' }}>
                <div style={{ padding: '20px 30px', maxHeight: '80vh', overflowY: 'auto' }}>
                    <h3 style={{ textAlign: 'center', marginBottom: '25px', fontSize: '1.3rem', fontWeight: 'bold' }}>출금 신청 상세</h3>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <DetailRow label="원장번호" value={selectedBiling?.number} />
                        <DetailRow label="매니저이름" value={selectedBiling?.mg_name} />
                        <DetailRow label="은행이름" value={selectedBiling?.bank} />
                        <DetailRow label="계좌번호" value={selectedBiling?.bank_number} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <label style={{ width: '30%', fontWeight: 'bold', color: '#555', fontSize: '0.95rem' }}>포함된 오더</label>
                            <div style={{ width: '65%', textAlign: 'right', display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '10px' }}>
                                <span style={{ fontSize: '0.95rem', color: '#333' }}>
                                    {selectedBiling?.list ? (selectedBiling.list.length > 30 ? selectedBiling.list.substring(0, 30) + "..." : selectedBiling.list) : selectedBiling?.number}
                                </span>
                                <button
                                    onClick={handleViewOrderList}
                                    style={{
                                        padding: '4px 10px',
                                        backgroundColor: '#006edc',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '4px',
                                        cursor: 'pointer',
                                        fontSize: '0.8rem',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    보기
                                </button>
                            </div>
                        </div>
                        <DetailRow label="공급가액" value={selectedBiling ? Math.round(Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) / 1.1).toLocaleString() : '-'} />
                        <DetailRow label="부가세" value={selectedBiling ? (Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) - Math.round(Number(String(selectedBiling.total_payment).replace(/[^0-9]/g, '')) / 1.1)).toLocaleString() : '-'} />
                        <DetailRow label="합계금" value={selectedBiling?.total_payment} isBold color="#006edc" />
                        <DetailRow label="출금신청일자" value={selectedBiling?.regi_date} />
                        <DetailRow label="현재상태" value={selectedBiling?.payout_state} isBold color={selectedBiling?.payout_state === '반려' ? '#dc3545' : 'black'} />
                    </div>

                    {selectedBiling?.payout_state === '반려' && (
                        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '10px', borderLeft: '5px solid #dc3545' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '5px' }}>반려 사유</div>
                            <div style={{ fontSize: '0.95rem', color: '#333', lineHeight: '1.4', whiteSpace: 'pre-wrap' }}>{selectedBiling?.description || "사유 없음"}</div>
                        </div>
                    )}

                    <hr style={{ margin: '20px 0', border: '0', borderTop: '1px solid #eee' }} />

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <ConfirmRow label="완료유무-확인자" confirmer={selectedBiling?.confirm_photo} onConfirm={() => handleConfirm('photo')} onView={() => handleViewAttachment('완료사진')} />
                        <ConfirmRow
                            label="A/S유무-확인자"
                            confirmer={selectedBiling?.confirm_as}
                            onConfirm={() => handleConfirm('as')}
                            onView={() => handleViewAttachment('A/S자료')}
                            showViewButton={selectedBiling?.as_list && selectedBiling.as_list.length > 0}
                        />
                        <ConfirmRow label="수입자료-확인자" confirmer={selectedBiling?.confirm_paper} onConfirm={() => handleConfirm('paper')} onView={() => handleViewAttachment('수입자료')} />
                    </div>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', padding: '20px 30px', backgroundColor: '#f9f9f9', borderTop: '1px solid #eee', borderRadius: '0 0 12px 12px' }}>
                    <button onClick={() => modalCorrective.current.close()} style={{ padding: '10px 30px', backgroundColor: 'white', color: '#333', border: '1px solid #ccc', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold' }}>취소</button>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        <button onClick={() => handleStatusChange("반려")} disabled={isFinished} style={{ padding: '10px 30px', backgroundColor: isFinished ? '#f0f0f0' : 'white', color: isFinished ? '#aaa' : '#dc3545', border: '1px solid ' + (isFinished ? '#ccc' : '#dc3545'), borderRadius: '6px', cursor: isFinished ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}>반려</button>
                        <button onClick={() => handleStatusChange("완료")} disabled={!isAllConfirmed || isFinished} style={{ padding: '10px 30px', backgroundColor: (!isAllConfirmed || isFinished) ? '#f0f0f0' : '#006edc', color: (!isAllConfirmed || isFinished) ? '#aaa' : 'white', border: '1px solid ' + ((!isAllConfirmed || isFinished) ? '#ccc' : '#006edc'), borderRadius: '6px', cursor: (!isAllConfirmed || isFinished) ? 'not-allowed' : 'pointer', fontWeight: 'bold' }}>지급</button>
                    </div>
                </div>
            </dialog>

            {/* 예약번호 선택 모달 */}
            <dialog
                ref={modalSelection}
                onClose={() => setSelectionState(prev => ({ ...prev, isOpen: false }))}
                style={{
                    padding: '20px',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    minWidth: '300px',
                    textAlign: 'center',
                    zIndex: 2000
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', fontWeight: 'bold' }}>예약 번호 선택</h3>
                <p style={{ marginBottom: '20px', fontSize: '0.9rem', color: '#666' }}>확인할 예약 번호를 선택해주세요.</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {selectionState.reqNumbers.map((num, idx) => (
                        <button
                            key={idx}
                            onClick={() => fetchAndOpenGallery(num, selectionState.type)}
                            style={{
                                padding: '12px',
                                backgroundColor: '#f0f8ff',
                                border: '1px solid #006edc',
                                borderRadius: '8px',
                                color: '#006edc',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                transition: 'background 0.2s'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#e1f0ff'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                        >
                            {num}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setSelectionState(prev => ({ ...prev, isOpen: false }))}
                    style={{
                        marginTop: '20px',
                        padding: '8px 20px',
                        backgroundColor: '#eee',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    취소
                </button>
            </dialog>

            {/* 오더 리스트 모달 */}
            <dialog
                ref={modalOrderList}
                onClose={() => setOrderListState(prev => ({ ...prev, isOpen: false }))}
                style={{
                    padding: '20px',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                    minWidth: '300px',
                    textAlign: 'center',
                    zIndex: 2000
                }}
            >
                <h3 style={{ marginTop: 0, marginBottom: '20px', fontSize: '1.1rem', fontWeight: 'bold' }}>포함된 오더 목록</h3>
                <p style={{ marginBottom: '20px', fontSize: '0.9rem', color: '#666' }}>상세 정보를 볼 오더를 선택해주세요.</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
                    {orderListState.orders.map((num, idx) => (
                        <button
                            key={idx}
                            onClick={() => handleOrderClick(num)}
                            style={{
                                padding: '12px',
                                backgroundColor: '#fff',
                                border: '1px solid #ddd',
                                borderRadius: '8px',
                                color: '#333',
                                fontWeight: 'bold',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                transition: 'all 0.2s'
                            }}
                            onMouseOver={(e) => {
                                e.target.style.backgroundColor = '#f0f8ff';
                                e.target.style.borderColor = '#006edc';
                                e.target.style.color = '#006edc';
                            }}
                            onMouseOut={(e) => {
                                e.target.style.backgroundColor = '#fff';
                                e.target.style.borderColor = '#ddd';
                                e.target.style.color = '#333';
                            }}
                        >
                            {num}
                        </button>
                    ))}
                </div>
                <button
                    onClick={() => setOrderListState(prev => ({ ...prev, isOpen: false }))}
                    style={{
                        marginTop: '20px',
                        padding: '8px 20px',
                        backgroundColor: '#eee',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer'
                    }}
                >
                    닫기
                </button>
            </dialog>

            {/* 갤러리 모달 */}
            <dialog
                ref={modalGallery}
                onClose={closeGallery}
                style={{
                    padding: 0,
                    border: 'none',
                    borderRadius: '12px',
                    width: '80%',
                    maxWidth: '900px',
                    height: '80vh',
                    maxHeight: '90vh',
                    boxShadow: '0 5px 30px rgba(0,0,0,0.3)',
                    backgroundColor: 'transparent',
                    overflow: 'hidden'
                }}
            >
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    height: '100%',
                    width: '100%'
                }}>
                    <div style={{ padding: '15px 20px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#fff', flexShrink: 0 }}>
                        <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold' }}>
                            {galleryState.type === 'work' ? '완료 사진 (16장)' : 'A/S 완료 사진 (4장)'}
                        </h3>
                        <button onClick={closeGallery} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>✕</button>
                    </div>

                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '20px',
                        backgroundColor: '#fff',
                        minHeight: 0
                    }}>
                        {galleryState.images.length > 0 && (
                            <GalleryGrid
                                type={galleryState.type}
                                images={galleryState.images}
                                userId={galleryState.userId}
                                reservationId={galleryState.reservationId}
                                onImageClick={setViewImage}
                            />
                        )}
                    </div>

                    <div style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'center', backgroundColor: '#f9f9f9', flexShrink: 0 }}>
                        <button
                            onClick={closeGallery}
                            style={{
                                padding: '10px 40px',
                                backgroundColor: '#006edc',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                fontSize: '1rem',
                                fontWeight: 'bold',
                                cursor: 'pointer'
                            }}
                        >
                            확인
                        </button>
                    </div>
                </div>
            </dialog>

            {/* 단일 이미지 확대 뷰어 (모달 형태) */}
            <dialog
                ref={modalImageViewer}
                onClose={() => setViewImage(null)}
                style={{
                    width: '80%',
                    maxWidth: '900px',
                    height: '80vh',
                    maxHeight: '90vh',
                    backgroundColor: 'white',
                    border: 'none',
                    borderRadius: '12px',
                    padding: 0,
                    boxShadow: '0 5px 30px rgba(0,0,0,0.3)',
                    overflow: 'hidden'
                }}
            >
                {viewImage && (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        {/* 헤더 */}
                        <div style={{
                            padding: '15px 20px',
                            borderBottom: '1px solid #eee',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            backgroundColor: '#fff',
                            flexShrink: 0
                        }}>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold' }}>세금계산서</h3>
                            <button onClick={() => setViewImage(null)} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', lineHeight: 1 }}>✕</button>
                        </div>
                        {/* 이미지 영역 */}
                        <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px', backgroundColor: '#f5f5f5', overflow: 'auto' }}>
                            <TransformWrapper initialScale={1}>
                                <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }}>
                                    <img src={viewImage} alt="세금계산서" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                </TransformComponent>
                            </TransformWrapper>
                        </div>
                        {/* 하단 버튼 */}
                        <div style={{ padding: '15px 20px', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'center', backgroundColor: '#f9f9f9', flexShrink: 0 }}>
                            <button
                                onClick={() => setViewImage(null)}
                                style={{
                                    padding: '10px 40px',
                                    backgroundColor: '#006edc',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '1rem',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                확인
                            </button>
                        </div>
                    </div>
                )}
            </dialog>
        </div>
    );
}

const GalleryGrid = ({ type, images, userId, reservationId, onImageClick }) => {
    const getSrc = (imgName) => {
        const pathType = type === 'work' ? 'work_process' : 'as_complete';
        return `/imagesRead/${pathType}/${userId}/${reservationId}/${imgName}`;
    };

    if (type === 'work') {
        const labels = ["필터그릴", "필터", "프론트", "드레인 판", "핀 세척", "송풍팬", "스티커", "복장체크"];
        const sortedImages = [...images].sort();

        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                {labels.map((label, rowIdx) => {
                    const imgBefore = sortedImages[rowIdx * 2];
                    const imgAfter = sortedImages[rowIdx * 2 + 1];

                    return (
                        <React.Fragment key={rowIdx}>
                            <ImageCard
                                label={`${label} (전)`}
                                src={imgBefore ? getSrc(imgBefore) : null}
                                onClick={onImageClick}
                            />
                            <ImageCard
                                label={`${label} (후)`}
                                src={imgAfter ? getSrc(imgAfter) : null}
                                onClick={onImageClick}
                            />
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
    else {
        return (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                {images.map((imgName, idx) => (
                    <ImageCard
                        key={idx}
                        label={`AS 완료사진 ${idx + 1}`}
                        src={getSrc(imgName)}
                        onClick={onImageClick}
                    />
                ))}
            </div>
        );
    }
};

const ImageCard = ({ label, src, onClick }) => (
    <div style={{ border: '1px solid #ddd', borderRadius: '8px', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ backgroundColor: '#f7f7f7', padding: '8px', fontSize: '0.85rem', fontWeight: 'bold', textAlign: 'center', borderBottom: '1px solid #eee' }}>{label}</div>
        <div style={{ height: '150px', backgroundColor: '#eee', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: src ? 'pointer' : 'default' }} onClick={() => src && onClick(src)}>
            {src ? <img src={src} alt={label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ color: '#aaa', fontSize: '0.8rem' }}>이미지 없음</span>}
        </div>
    </div>
);

const DetailRow = ({ label, value, isBold = false, color = 'black' }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <label style={{ width: '30%', fontWeight: 'bold', color: '#555', fontSize: '0.95rem' }}>{label}</label>
        <div style={{ width: '65%', textAlign: 'right', wordBreak: 'break-all', fontWeight: isBold ? 'bold' : 'normal', color: color, fontSize: '0.95rem' }}>{value || '-'}</div>
    </div>
);

const ConfirmRow = ({ label, confirmer, onConfirm, onView, showViewButton = true }) => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <label style={{ width: '30%', fontWeight: 'bold', color: '#333', fontSize: '0.95rem' }}>{label}</label>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', width: '65%', justifyContent: 'flex-end' }}>
            {showViewButton && (
                <span onClick={onView} style={{ color: '#006edc', textDecoration: 'underline', cursor: 'pointer', fontSize: '0.9rem' }}>첨부보기</span>
            )}
            {confirmer ? (
                <span style={{ color: '#006edc', fontWeight: 'bold', minWidth: '50px', textAlign: 'center' }}>{confirmer}</span>
            ) : (
                <button onClick={onConfirm} style={{ padding: '5px 15px', backgroundColor: 'white', color: '#006edc', border: '1px solid #006edc', borderRadius: '4px', cursor: 'pointer', fontSize: '0.85rem', fontWeight: 'bold' }}>확인</button>
            )}
        </div>
    </div>
);



const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 20px; padding-bottom: 20px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li { display: inline-block; width: 30px; height: 30px; border: 1px solid #e2e2e2; display: flex; justify-content: center; align-items: center; font-size: 1rem; margin: 0 2px; cursor: pointer; }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; border-color: #337ab7; }
`;

const TopControlContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 90%;
    margin: 30px auto 10px auto;
`;

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    width: auto;
    min-width: 400px;
    max-width: 500px;
`;

const FilterContainer = styled.div`
    display: flex;
    gap: 15px;
    margin: 0; // margin 제거 (부모 컨테이너에서 제어)
    .checkbox-label { display: flex; alignItems: center; fontSize: 0.9rem; cursor: pointer; fontWeight: bold; }
    input[type="checkbox"] { margin-right: 5px; width: 16px; height: 16px; cursor: pointer; }
    .indicator { width: 10px; height: 10px; borderRadius: 50%; marginRight: 5px; display: inline-block; }
    .indicator.apply { background-color: #006edc; }
    .indicator.complete { background-color: #28a745; }
    .indicator.reject { background-color: #dc3545; }
`;

const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;
    
    &:focus {
        outline: none;
        border-color: #006edc;
    }
    
    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    
    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

export default TotalBiling;
